import type { ListBuilderList } from '../../../types';
import { createQuoteShopStandardColumns } from '../columns';
import {
	QUOTE_SHOP_MOBILE_CARD_CONFIG,
	QUOTE_SHOP_STANDARD_REQUIRED_FIELDS,
} from '../shared';

/**
 * Quote Shop Short Date list configuration
 * Items with short expiration dates
 */
export const quoteShopShortDateList: ListBuilderList = {
	id: 'quote_shop_short_date',
	cacheTTL: 600000,
	name: 'Short Date',
	type: 'default',
	active: true,
	sortOrder: 4,
	columns: createQuoteShopStandardColumns(),
	description: 'Items with short expiration dates',
	defaultSortId: 'in_stock_first',
	requiredFields: QUOTE_SHOP_STANDARD_REQUIRED_FIELDS,
	mobileCardConfig: QUOTE_SHOP_MOBILE_CARD_CONFIG,
	filterRules: {
		item_filters: {
			defaultValue: [
				{
					id: 'short_date',
					label: 'Short Date',
				},
				{
					id: 'in_stock',
					label: 'In Stock',
				},
			],
		},
	},
};
